import { DataTable } from "@circle-react-uikit/DataTableV2";
import { usePaywallChargesList } from "./hooks/usePaywallChargesList";

export interface PaywallChargesListProps {
  chargesData: any;
  columnsToRender: any;
  onClickPagination: (page: number) => void;
  wrapperClassName?: string;
}

export const PaywallChargesList = ({
  columnsToRender,
  chargesData,
  onClickPagination,
  wrapperClassName,
}: PaywallChargesListProps) => {
  const { onChangeSorting } = usePaywallChargesList({ chargesData });

  return (
    <DataTable.TableWrapper className={wrapperClassName}>
      <DataTable
        onChangeSorting={onChangeSorting}
        columns={columnsToRender}
        data={chargesData?.charges ?? []}
        isLoading={chargesData?.isLoadingCharges}
        initialPage={chargesData?.page ?? 1}
        onChangePage={onClickPagination}
        totalRecordsCount={chargesData?.totalCharges}
        pageSize={chargesData.perPage}
      >
        <DataTable.Table>
          <DataTable.SortableHead />
          <DataTable.Loader />
          <DataTable.Body />
        </DataTable.Table>
        <DataTable.Pagination align="left" direction="reverse" />
      </DataTable>
    </DataTable.TableWrapper>
  );
};
